import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import CardNews from '../components/CardNews';

function NewsGetAll() {
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchResponse = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/site/newsLatest`);
        setResponse(response.data || []);
      } catch (err) {
        setError('No se pudo cargar el contenido.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchResponse();
  }, []);

  if (loading) {
    return (
      <div>
        <Container>Cargando...</Container>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Container>{error}</Container>
      </div>
    );
  }

  return (
    <div>
      <Container>
        {response.map((item, idx) => (
          <CardNews title={item.title} date={item.date} description={item.description} />
        ))}
      </Container>
    </div>
  );
}

export default NewsGetAll;